import { render } from "./alertModal.vue?vue&type=template&id=0be6d6e7"
import script from "./alertModal.vue?vue&type=script&lang=js"
export * from "./alertModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__